export class SearchEmployeeFilter {
  excludedEmployeeId!: number[];
  excludedQuitDepartmentId!: boolean;
  firstName = '';
  lastName = '';
  pageIndex = 1;
  pageSize = 10;
  recursive = false;
  roleId!: number;
  employeeId!: string;
  departmentId!: string;
  loginName!: string;
  keyword!: string;
  fromDate!: Date;
  toDate!: Date;
  sortDirection!: string;
}
